"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _commonHelper = require("../helpers/commonHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var MAX_SEG_COUNT = 12;
var Layout = function Layout(props) {
  var newChildren = [];
  var _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 0 : _props$gap;
  if (children && children.length && gap) {
    var colsD = 0;
    var colsT = 0;
    var colsM = 0;

    // array holding all the rows
    var rowsD = [];
    var rowsT = [];
    var rowsM = [];

    // individual row holding children
    var arrayD = [];
    var arrayT = [];
    var arrayM = [];
    children.forEach(function (ch) {
      if (ch && ch.props) {
        var _ch$props = ch.props,
          _ch$props2 = _ch$props === void 0 ? {} : _ch$props,
          _ch$props2$colD = _ch$props2.colD,
          colD = _ch$props2$colD === void 0 ? 0 : _ch$props2$colD,
          _ch$props2$colT = _ch$props2.colT,
          colT = _ch$props2$colT === void 0 ? 0 : _ch$props2$colT,
          _ch$props2$colM = _ch$props2.colM,
          colM = _ch$props2$colM === void 0 ? 0 : _ch$props2$colM;
        colsD += colD;
        colsT += colT;
        colsM += colM;

        // make rows according to columns for diff screens
        if (colsD == 12) {
          arrayD.push(ch);
          rowsD.push(arrayD);
          colsD = 0;
          arrayD = [];
        } else if (colsD > 12) {
          rowsD.push(arrayD);
          arrayD = [ch];
          colsD = colD;
        } else {
          arrayD.push(ch);
        }
        if (colsT == 12) {
          arrayT.push(ch);
          rowsT.push(arrayT);
          colsT = 0;
          arrayT = [];
        } else if (colsT > 12) {
          rowsT.push(arrayT);
          arrayT = [ch];
          colsT = colT;
        } else {
          arrayT.push(ch);
        }
        if (colsM == 12) {
          arrayM.push(ch);
          rowsM.push(arrayM);
          colsM = 0;
          arrayM = [];
        } else if (colsM > 12) {
          rowsM.push(arrayM);
          arrayM = [ch];
          colsM = colM;
        } else {
          arrayM.push(ch);
        }
      }
    });

    // push child if remains
    if (arrayD.length) {
      arrayD.isPartialyFill = true;
      rowsD.push(arrayD);
    }
    if (arrayT.length) {
      arrayT.isPartialyFill = true;
      rowsT.push(arrayT);
    }
    if (arrayM.length) {
      arrayT.isPartialyFill = true;
      rowsM.push(arrayM);
    }

    // add padding in every row
    var paddedD = addPadding(rowsD, gap);
    var paddedT = addPadding(rowsT, gap);
    var paddedM = addPadding(rowsM, gap);
    var id = 1;
    rowsD.forEach(function (row) {
      row.forEach(function (ch) {
        newChildren.push((0, _commonHelper.cloneChildren)(ch, {
          leftGapD: paddedD[id].leftGap,
          rightGapD: paddedD[id].rightGap,
          leftGapT: paddedT[id].leftGap,
          rightGapT: paddedT[id].rightGap,
          leftGapM: paddedM[id].leftGap,
          rightGapM: paddedM[id].rightGap,
          gap: gap
        }));
        id++;
      });
    });
  }
  return /*#__PURE__*/_react["default"].createElement(Layout.Wrapper, props, gap ? newChildren : children);
};
var addPadding = function addPadding(rows, gap) {
  var ch_id = 0;
  var all_gaps = {};
  var prevCount;
  rows.forEach(function (row, i) {
    var count = row.length;
    if (i && i === rows.length - 1 && row.length && row.isPartialyFill) {
      count = prevCount;
    }
    prevCount = count;
    var gapForOne = (count - 1) * gap / count;
    var gaps = [];
    row.forEach(function (ch, j) {
      var lastGap = gaps[gaps.length - 1] || 0;
      var leftGap = 0;
      var rightGap = 0;
      leftGap = gap - lastGap;
      rightGap = gapForOne - leftGap;
      if (j == 0) {
        leftGap = 0;
        rightGap = gapForOne;
      } else if (j == count - 1) {
        rightGap = 0;
        leftGap = gapForOne;
      }
      gaps.push(leftGap);
      gaps.push(rightGap);
      ch_id++;
      all_gaps[ch_id] = {
        leftGap: leftGap,
        rightGap: rightGap
      };
    });
  });
  return all_gaps;
};
Layout.propTypes = {
  children: _propTypes["default"].node,
  gap: _propTypes["default"].number
};
Layout.Wrapper = _styledComponents["default"].div.withConfig({
  componentId: "sc-bke1zw-0"
})(["width:100%;position:relative;display:flex;flex-wrap:wrap;"]);
var getWidth = function getWidth(col) {
  return "".concat(col / MAX_SEG_COUNT * 100, "%");
};
Layout.Item = _styledComponents["default"].div.withConfig({
  componentId: "sc-bke1zw-1"
})(["position:relative;width:100%;flex-grow:0;flex-shrink:0;", " ", " ", ""], function (props) {
  return props.colD && (0, _styledComponents.css)(["max-width:", ";padding:", ";"], function (props) {
    return getWidth(props.colD);
  }, function (props) {
    return props.gap ? "0 ".concat(props.rightGapD, "px ").concat(props.gap, "px ").concat(props.leftGapD, "px") : "0";
  });
}, function (props) {
  return props.colT && (0, _styledComponents.css)(["@media (max-width:768px) and (min-width:481px){max-width:", ";padding:", ";}"], function (props) {
    return getWidth(props.colT);
  }, function (props) {
    return props.gap ? "0 ".concat(props.rightGapT, "px ").concat(props.gap, "px ").concat(props.leftGapT, "px") : "0";
  });
}, function (props) {
  return props.colM && (0, _styledComponents.css)(["@media (max-width:480px){padding:", ";max-width:", ";}"], function (props) {
    return props.gap ? "0 ".concat(props.rightGapM, "px ").concat(props.gap, "px ").concat(props.leftGapM, "px") : "0";
  }, function (props) {
    return getWidth(props.colM);
  });
});
var _default = exports["default"] = Layout;